export default "__VITE_ASSET__DY1iInfv__"